var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1 Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contact-Window",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "005_Contact_Private",
    transform: "translate(-438.000000, -211.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy-4",
    transform: "translate(438.000000, 211.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 9.99978571 0 7.85692857 5.35714286 2.49978571 7.5 4.64264286 2.14285714 9.99978571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.42857143,1.42835714 L7.54285714,0.313357143 C7.96142857,-0.1045 8.64,-0.1045 9.05857143,0.313357143 L9.68571429,0.941214286 C10.1042857,1.35978571 10.1042857,2.03835714 9.68571429,2.45621429 L8.57142857,3.57121429 L6.42857143,1.42835714 Z",
    id: "Fill-2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.4a8b20a4cef608f04e5b8481327c5bb2.svg";
export { ForwardRef as ReactComponent };